import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const TextContainer = styled.div`
    align-items: center;
    color: #2A2A33;
    display: flex;
    flex-basis: 100%;
    flex-wrap: wrap;
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    font-weight: bold;
    line-height: 32px;
    justify-content: center;
    margin: 0 auto;
    order: 2
    text-align: center;
    width: 100%;

    @media ${breakpoints.large} {
        max-width: 444px;
    }

    @media ${breakpoints.extraLarge} {
        margin: 0;
        max-width: 50%;
        order: ${({ order }) => order || 1};
        padding-right: ${({ order }) => (order === 1 ? '106px' : '0')};
        text-align: left;
        width: 50%;
    }
`;
